import React from 'react';
import { Listing } from '@/components/Listing';
import { RoommateCard } from '@/components/RoommateCard';
import { ClassifiedCard } from '@/components/ClassifiedCard';

export type HousingType = 'listing' | 'roommate' | 'classified';

export interface HousingPosting {
  id: number;
  type: HousingType;
  data: any;
}

interface UnifiedCardProps {
  posting: HousingPosting;
  signedIn: boolean;
  onBlocked: () => void;
}

export function UnifiedCard({ posting, signedIn, onBlocked }: UnifiedCardProps) {
  return (
    <div className="col mb-4">
      <div className="position-relative h-100">
        {posting.type === 'listing' && (
          <Listing
            signedIn={signedIn}
            listingDetails={posting.data}
            blockCallback={onBlocked}
            withColumn={false}
            showTypeBadge
          />
        )}
        {posting.type === 'roommate' && (
          <RoommateCard
            roommate={posting.data}
            signedIn={signedIn}
            favorited={posting.data.favorited}
            blocked={posting.data.blocked}
            blockCallback={onBlocked}
            showTypeBadge
          />
        )}
        {posting.type === 'classified' && (
          <ClassifiedCard
            classified={posting.data}
            signedIn={signedIn}
            favorited={posting.data.favorited}
            blocked={posting.data.blocked}
            blockCallback={onBlocked}
            showTypeBadge
          />
        )}
      </div>
    </div>
  );
}
